import { useEffect, useState, cloneElement } from 'react';
import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import { Copy } from 'assets/icons';
import { useFloating, flip, offset } from '@floating-ui/react';

import * as S from './CopyString.styled';

const copyToClipboard = (text) => {
  //navigator.clipboard.writeText(text);
  copy(text);
};

const CopyString = ({ label, text, isHidden, icon = <Copy /> }) => {
  if (typeof text !== 'string' || text.length === 0) {
    return null;
  }

  const textToShow = isHidden ? '' : text;

  const [isClicked, setIsClicked] = useState(false);

  const { x, y, strategy, refs } = useFloating({
    middleware: [flip(), offset(9)],
    placement: 'top-start',
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsClicked(false);
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [isClicked]);
  return (
    <S.Container>
      {label && <S.Label>{`${label}:`}</S.Label>}
      {textToShow && <S.Text>{textToShow}</S.Text>}
      <S.CopyIconWrapper
        onClick={() => {
          copyToClipboard(text);
          setIsClicked(true);
        }}
      >
        <S.IconContainer ref={refs.setReference}>{icon && cloneElement(icon)}</S.IconContainer>
        <S.ParentContainer>
          {isClicked && (
            <S.CopiedMessage
              ref={refs.setFloating}
              style={{
                position: strategy,
                top: y ?? 0,
                left: x - 10 ?? 0,
                width: 'max-content',
              }}
            >
              Copied
            </S.CopiedMessage>
          )}
        </S.ParentContainer>
      </S.CopyIconWrapper>
    </S.Container>
  );
};

CopyString.propTypes = {
  label: PropTypes.string,
  isHidden: PropTypes.bool,
  text: PropTypes.string,
};

export default CopyString;
